import { useEffect, useState } from "react";
import { Col, Form, FormFeedback, Input, Label, Row } from "reactstrap";
import { useParameterGroundWaterbearingCreateMutation, useParameterGroundWaterbearingDeleteMutation, useParameterGroundWaterbearingFindAllQuery, useParameterGroundWaterbearingUpdateMutation } from "store";
import * as Yup from "yup";
import { useFormik } from "formik";
import Spinners from "Components/Common/Spinner";
import { Link, useParams } from "react-router-dom";
import Switch from "react-switch";
import groundwaterSvg from "../../../assets/images/svg/groundwater.svg"
import DeleteModal from "Components/Common/DeleteModal";
import Flatpickr from "react-flatpickr";

const WaterBearing = ({ boreholeId }: any) => {
  const { id } = useParams();
  const [isLoading, setLoading] = useState(true)

  const { data, error, isFetching } = useParameterGroundWaterbearingFindAllQuery(`?groundwater_id=${id}&groundwater_borehole_parameter_id=${boreholeId}`);
  const [waterBearingCreate, waterBearingCreateResult] = useParameterGroundWaterbearingCreateMutation();
  const [waterBearingUpdate, waterBearingUpdateResult] = useParameterGroundWaterbearingUpdateMutation();
  const [waterBearingDelete, waterBearingDeleteResult] = useParameterGroundWaterbearingDeleteMutation();

  const [waterbearing, setWaterbearing] = useState<any>();

  const [is_newCreated, setIs_newCreated] = useState<boolean>(false);
  const [measurementList, setMeasurementList] = useState<any>();
  const [meaCount, setMeaCount] = useState<any>();

  useEffect(() => {
    if (waterbearing === undefined) {
      setLoading(true);
    } else {
      setLoading(false);
    }
    if (data?.data.length !== 0) {
      setMeasurementList(data?.data);
      setMeaCount(measurementList?.length);
    } else {
      setMeasurementList(null)
      setMeaCount(null)
      setLoading(true);
      setWaterbearing(null)
    }
    if (is_newCreated) {
      setLoading(false);
    }
  }, [waterbearing, id, data?.data, boreholeId])


  const validation: any = useFormik({
    enableReinitialize: true,

    initialValues: {
      id: waterbearing?.id,
      groundwater_id: waterbearing?.groundwater_id,
      groundwater_code: waterbearing?.groundwater_code,
      measure_date: waterbearing?.measure_date,
      // groundwater_borehole_parameter_id: waterbearing?.groundwater_borehole_parameter_id,
      groundwater_borehole_parameter_code: waterbearing?.groundwater_borehole_parameter_code,
      hydrogeological_borehole_code: waterbearing?.hydrogeological_borehole_code,
      hydrogeological_borehole_coefficient: waterbearing?.hydrogeological_borehole_coefficient,
      water_conductivity_coefficient: waterbearing?.water_conductivity_coefficient,
      level_change_coefficient: waterbearing?.level_change_coefficient,
      waterbearing_parameter: waterbearing?.waterbearing_parameter,
      pumping_test_type: waterbearing?.pumping_test_type,
      waterbearing_rocks_lithological: waterbearing?.waterbearing_rocks_lithological,
      rocks_index_geologicalage: waterbearing?.rocks_index_geologicalage,
    },
    validationSchema: Yup.object({
      groundwater_code: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      measure_date: Yup.date().typeError("Он сар өдөр оруулна уу").required("Утга оруулна уу !"),
      hydrogeological_borehole_code: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      hydrogeological_borehole_coefficient: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"), water_conductivity_coefficient: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      level_change_coefficient: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      waterbearing_parameter: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      groundwater_borehole_parameter_code: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("утга оруулна уу !"),
      pumping_test_type: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      waterbearing_rocks_lithological: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      rocks_index_geologicalage: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      if (waterbearing !== null) {
        const updateList = {
          id: waterbearing?.id,
          groundwater_id: waterbearing?.groundwater_id,
          groundwater_code: values.groundwater_code,
          measure_date: values.measure_date,
          // groundwater_borehole_parameter_id: values.groundwater_borehole_parameter_id,
          groundwater_borehole_parameter_code: values.groundwater_borehole_parameter_code,
          hydrogeological_borehole_code: values.hydrogeological_borehole_code,
          hydrogeological_borehole_coefficient: values.hydrogeological_borehole_coefficient,
          water_conductivity_coefficient: values.water_conductivity_coefficient,
          level_change_coefficient: values.level_change_coefficient,
          waterbearing_parameter: values.waterbearing_parameter,
          pumping_test_type: values.pumping_test_type,
          waterbearing_rocks_lithological: values.waterbearing_rocks_lithological,
          rocks_index_geologicalage: values.rocks_index_geologicalage,
        }
        waterBearingUpdate(updateList);
      } else {
        const newList = {
          groundwater_id: id,
          groundwater_code: values["groundwater_code"],
          measure_date: values["measure_date"],
          groundwater_borehole_parameter_id: boreholeId,
          groundwater_borehole_parameter_code: values["groundwater_borehole_parameter_code"],
          hydrogeological_borehole_code: values["hydrogeological_borehole_code"],
          hydrogeological_borehole_coefficient: values["hydrogeological_borehole_coefficient"],
          water_conductivity_coefficient: values["water_conductivity_coefficient"],
          level_change_coefficient: values["level_change_coefficient"],
          waterbearing_parameter: values["waterbearing_parameter"],
          pumping_test_type: values["pumping_test_type"],
          waterbearing_rocks_lithological: values["waterbearing_rocks_lithological"],
          rocks_index_geologicalage: values["rocks_index_geologicalage"],
        };
        waterBearingCreate(newList)
      }
      // validation.resetForm();
    },
  });

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Үгүй
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Тийм
      </div>
    );
  };

  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = () => {
    setDeleteModal(true);
  };

  const handleDeletejob = () => {
    if (waterbearing) {
      waterBearingDelete(waterbearing.id);
      setDeleteModal(false);
    }
    setWaterbearing(null);
    setIs_newCreated(true)
  };

  return (

    <>
      <Row>
        <Col lg={12}>
          <div className="d-flex align-items-center mb-3">
            <img src={groundwaterSvg} alt="" height="50" />
            <div className="flex-grow-1 ms-3">
              <h5 className="fw-semibold">Мэдээлэл</h5>
              <ul className="list-unstyled hstack gap-2 mb-0">
                <li>
                  <i className="mdi mdi-table-row-height"></i>{" "}
                  <span className="text-muted fw-semibold">
                    Нийт: {meaCount}
                  </span>
                </li>
              </ul>
            </div>

            <button
              type="button"
              disabled={is_newCreated === true ? true : false}
              className="btn btn-success  btn-label me-3"
              onClick={() => {
                validation.resetForm();
                setWaterbearing(null);
                setIs_newCreated(true);
              }}
            >
              <i className="mdi mdi-file-plus-outline label-icon"></i>
              Шинээр нэмэх
            </button>
            {
              is_newCreated === false && waterbearing !== null ?
                <button
                  type="button"
                  onClick={(event: any) => {
                    event.preventDefault();
                    onClickDelete();
                  }}
                  className="btn btn-danger  btn-label"
                >
                  <i className="mdi mdi-delete-empty-outline label-icon"></i> Устгах
                </button>
                : ''
            }
          </div>
        </Col>
      </Row>
      <Row>
        <DeleteModal
          deleteName={waterbearing?.rocks_index_geologicalage}
          show={deleteModal}
          onDeleteClick={handleDeletejob}
          onCloseClick={() => setDeleteModal(false)}
        />
        <Col lg={3}>
          <ul className="verti-timeline list-unstyled">
            {measurementList?.map((item, index) => (
              <li className="event-list active">
                <div className="event-timeline-dot">
                  <i className="bx bxs-right-arrow-circle font-size-18 bx-fade-right" />
                </div>
                <div className="flex-shrink-0 d-flex">
                  <div key={index} className="d-flex mb-3">
                    <div className="me-3">
                      <h5 className="font-size-14">
                        {item?.created_at.split("T")[0]}
                        <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                      </h5>
                    </div>
                    <div className="flex-grow-1">
                      <div>
                        <Link
                          to="#"
                          className="cursor fw-semibold"
                          onClick={() => {
                            setIs_newCreated(false)
                            setWaterbearing(item)
                          }}
                        >
                          {item?.measure_date}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </Col>
        <Col lg={9}>
          {
            isLoading ? <Spinners setLoading={setLoading} sCustomTop={'120px'} /> :
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <Row>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label className="fw-semibold"> Бүртгэлийн дугаар </Label>
                      <Input
                        name="groundwater_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.groundwater_code || ""}
                        invalid={
                          validation.touched.groundwater_code &&
                            validation.errors.groundwater_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.groundwater_code &&
                        validation.errors.groundwater_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.groundwater_code}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ус агуулагч чулуулгийн литологийн бүрэлдэхүүн </Label>
                      <Input
                        name="waterbearing_rocks_lithological"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.waterbearing_rocks_lithological || ""}
                        invalid={
                          validation.touched.waterbearing_rocks_lithological &&
                            validation.errors.waterbearing_rocks_lithological
                            ? true
                            : false
                        }
                      />
                      {validation.touched.waterbearing_rocks_lithological &&
                        validation.errors.waterbearing_rocks_lithological ? (
                        <FormFeedback type="invalid">
                          {validation.errors.waterbearing_rocks_lithological}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Уст үе давхрага, цогцолборын ус өгөмж, μ </Label>
                      <Input
                        name="waterbearing_parameter"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.waterbearing_parameter || ""}
                        invalid={
                          validation.touched.waterbearing_parameter &&
                            validation.errors.waterbearing_parameter
                            ? true
                            : false
                        }
                      />
                      {validation.touched.waterbearing_parameter &&
                        validation.errors.waterbearing_parameter ? (
                        <FormFeedback type="invalid">
                          {validation.errors.waterbearing_parameter}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Шавхалтын төрөл туршилт </Label>
                      <Input
                        name="pumping_test_type"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.pumping_test_type || ""}
                        invalid={
                          validation.touched.pumping_test_type &&
                            validation.errors.pumping_test_type
                            ? true
                            : false
                        }
                      />
                      {validation.touched.pumping_test_type &&
                        validation.errors.pumping_test_type ? (
                        <FormFeedback type="invalid">
                          {validation.errors.pumping_test_type}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Хэмжилт хийсэн огноо </Label>
                      <Flatpickr
                        className="form-control d-block"
                        placeholder="Огноо"
                        name="measure_date"
                        value={validation.values.measure_date}
                        onChange={(selectDate: Date[]) => {
                          if (selectDate[0]) {
                            const localDate = new Date(selectDate[0].getTime() - selectDate[0].getTimezoneOffset() * 60000)
                              .toISOString()
                              .split('T')[0];
                            validation.setFieldValue('measure_date', localDate);
                          }
                        }}
                        options={{
                          altInput: true,
                          altFormat: "Y-m-d",
                          dateFormat: "Y-m-d",
                          enableTime: false,
                        }}
                      />
                      {validation.touched.measure_date &&
                        validation.errors.measure_date ? (
                        <FormFeedback type="invalid">
                          {validation.errors.measure_date}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ус дамжуулах чадварын итгэлцүүр KH(km), м2/хоног</Label>
                      <Input
                        name="water_conductivity_coefficient"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.water_conductivity_coefficient || ""}
                        invalid={
                          validation.touched.water_conductivity_coefficient &&
                            validation.errors.water_conductivity_coefficient
                            ? true
                            : false
                        }
                      />
                      {validation.touched.water_conductivity_coefficient &&
                        validation.errors.water_conductivity_coefficient ? (
                        <FormFeedback type="invalid">
                          {validation.errors.water_conductivity_coefficient}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Чулуулгийн геологийн насны индекс </Label>
                      <Input
                        name="rocks_index_geologicalage"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.rocks_index_geologicalage || ""}
                        invalid={
                          validation.touched.rocks_index_geologicalage &&
                            validation.errors.rocks_index_geologicalage
                            ? true
                            : false
                        }
                      />
                      {validation.touched.rocks_index_geologicalage &&
                        validation.errors.rocks_index_geologicalage ? (
                        <FormFeedback type="invalid">
                          {validation.errors.rocks_index_geologicalage}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Чулуулгийн геологийн насны индекс </Label>
                      <Input
                        name="hydrogeological_borehole_coefficient"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.hydrogeological_borehole_coefficient || ""}
                        invalid={
                          validation.touched.hydrogeological_borehole_coefficient &&
                            validation.errors.hydrogeological_borehole_coefficient
                            ? true
                            : false
                        }
                      />
                      {validation.touched.hydrogeological_borehole_coefficient &&
                        validation.errors.hydrogeological_borehole_coefficient ? (
                        <FormFeedback type="invalid">
                          {validation.errors.hydrogeological_borehole_coefficient}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>

                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold">Гидрогеологийн цооногийн дугаар  </Label>
                      <Input
                        name="hydrogeological_borehole_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.hydrogeological_borehole_code || ""}
                        invalid={
                          validation.touched.hydrogeological_borehole_code &&
                            validation.errors.hydrogeological_borehole_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.hydrogeological_borehole_code &&
                        validation.errors.hydrogeological_borehole_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.hydrogeological_borehole_code}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold">Түвшний өөрчлөлтийн дамжуулалтын итгэлцүүр а, м2/хоног</Label>
                      <Input
                        name="level_change_coefficient"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.level_change_coefficient || ""}
                        invalid={
                          validation.touched.level_change_coefficient &&
                            validation.errors.level_change_coefficient
                            ? true
                            : false
                        }
                      />
                      {validation.touched.level_change_coefficient &&
                        validation.errors.level_change_coefficient ? (
                        <FormFeedback type="invalid">
                          {validation.errors.level_change_coefficient}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Цооногийн параметр код </Label>
                      <Input
                        name="groundwater_borehole_parameter_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.groundwater_borehole_parameter_code || ""}
                        invalid={
                          validation.touched.groundwater_borehole_parameter_code &&
                            validation.errors.groundwater_borehole_parameter_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.groundwater_borehole_parameter_code &&
                        validation.errors.groundwater_borehole_parameter_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.groundwater_borehole_parameter_code}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  <Col lg={12} className="d-flex justify-content-around mt-3">
                    <button type="submit" className="btn btn-primary"> Хадгалах </button>
                  </Col>
                </Row>
              </Form>
          }
        </Col>

      </Row>

    </>
  )
}

export default WaterBearing;